import { useState, useEffect } from 'react';
import { getPiConversion } from './piCurrency';

/**
 * Usage: <PiPrice pi={5} /> renders "5 Pi" then below it "≈ $5.00 · ₨315"
 * once the conversion loads (starts blank/loading, fills in async).
 */
export default function PiPrice({ pi, style, mutedStyle, suffix = '' }) {
  const [conversion, setConversion] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (pi && pi > 0) {
      getPiConversion(pi).then((c) => { if (!cancelled) setConversion(c); });
    }
    return () => { cancelled = true; };
  }, [pi]);

  return (
    <span>
      <span style={style}>{pi} Pi{suffix}</span>
      {conversion && (
        <span style={{ fontSize: 11, color: '#64748B', marginLeft: 6, ...mutedStyle }}>
          {'\u2248 ' + Number(conversion.usd).toFixed(2) + ' USDT' + (conversion.local != null ? ' \u00b7 ' + conversion.localSymbol + conversion.local + ' ' + conversion.localCode : '')}
        </span>
      )}
    </span>
  );
}
